__turbopack_context__.v({
  "acs_button": "ProductServices_Info-module-scss-module__WScnLq__acs_button",
  "cartServices": "ProductServices_Info-module-scss-module__WScnLq__cartServices",
  "item": "ProductServices_Info-module-scss-module__WScnLq__item",
  "item__price": "ProductServices_Info-module-scss-module__WScnLq__item__price",
  "productServices": "ProductServices_Info-module-scss-module__WScnLq__productServices",
  "root": "ProductServices_Info-module-scss-module__WScnLq__root",
  "title": "ProductServices_Info-module-scss-module__WScnLq__title",
  "wrap": "ProductServices_Info-module-scss-module__WScnLq__wrap",
});
